package com.tovtalk.utils.config

actual fun isWeb(): Boolean = true
